/*
 * Vertically aligns the collection-page breadcrumb ("Home > All Snowboards")
 * with the bottom of the collection banner's title/description text block
 * (see the "lps-breadcrumbs--on-banner" class in sections/LPS-breadcrumbs.liquid
 * and the matching rules in assets/LPS-custom.css, CUSTOMIZATIONS.md #87).
 *
 * Measured live rather than hardcoded: the banner's title text block (an
 * <rte-formatter> wrapping the <h1> and, when set, a description <p>) can be
 * any height depending on how much description text a given collection has,
 * and the banner itself can be any height depending on viewport width. A
 * fixed pixel offset broke as soon as either of those differed from the one
 * combination it was measured at (see #87's "v1" history).
 *
 * The breadcrumb's own .shopify-section wrapper is collapsed to height: 0
 * (see LPS-custom.css) and sits immediately before the banner in the
 * document, so its own top edge is a reliable stand-in for "the banner's
 * true top" - reliable specifically because, unlike the banner, it has no
 * overflowing content that could inflate a getBoundingClientRect() reading.
 */
(function () {
  function alignBreadcrumb() {
    var crumb = document.querySelector('.lps-breadcrumbs--on-banner');
    var main = document.getElementById('MainContent');
    if (!crumb || !main) return;

    var crumbSection = crumb.closest('.shopify-section');
    var banner = main.querySelector(':scope > .shopify-section');
    if (!crumbSection || !banner) return;

    var textBlock = banner.querySelector('rte-formatter') || banner.querySelector('h1');
    if (!textBlock) return;

    var bannerTop = crumbSection.getBoundingClientRect().top;
    var textBottom = textBlock.getBoundingClientRect().bottom;
    var offset = textBottom - bannerTop;
    if (!(offset > 0)) return;

    crumb.style.setProperty('--lps-breadcrumb-align-y', offset + 'px');
    crumb.classList.add('lps-breadcrumbs--aligned');
  }

  var scheduled = false;
  function scheduleAlign() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      alignBreadcrumb();
    });
  }

  scheduleAlign();
  window.addEventListener('resize', scheduleAlign);
  window.addEventListener('load', scheduleAlign);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleAlign);
  }
})();
